import styled from 'styled-components';

export const FnITabContainer = styled.div`
    @media (max-width: 768px) {
        .fDFRIS {
            margin-top: 2px !important;
        }
    }
`;
